<template>
    <div class="wrap-login">
        <!-- <nav>
            <img v-cloak class="icon-logo-small" :src="companyInfo.company_logo">
            <span v-cloak>{{companyInfo.company_name}}</span>
        </nav> -->
        <div class=" container-login">
            <img src="../assets/image/logo.png" class="icon-logo-big">
            
            <form role="form" class="form-horizontal" autocomplete="off" @submit.prevent="checkLoginInfo">
                <div class="form-group wrap-input">
                    <label for="user-login-name"></label>
                    <input type="text" id="user-login-name" placeholder="请输入您的邮箱号" v-model.trim="userInfo.username" @keyup="hideErrTip('name',userInfo.username)">
                    <label class="show-error" v-if="nameErr">{{nameErrText}}</label>
                </div>
                <div class="form-group wrap-input">
                    <label for="user-login-psw"></label>
                    <input type="password" id="user-login-psw" placeholder="请输入您的密码" v-model="userInfo.password" @keyup="hideErrTip('psw',userInfo.password)">
                    <label class="show-error" v-if=" pswErr">{{pswErrText}}</label>
                </div>
                <div class="form-group ">
                    <button type="submit" class=" btn-submit-login center-block">登录</button>
                </div>
            </form>
        </div>
        <z-lazyImg class="bg" :placeImg="bg_small" :src="bg" :mask="true"></z-lazyImg>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import bg_small from "src/assets/image/bg-place.png"
import bg from "src/assets/image/bg2.jpg"

export default {
    data() {
        return {
            bg_small,
            bg,

            nameErr: false,
            pswErr: false,
            nameErrText: '',
            pswErrText: '',
            userInfo: {
                username: '',
                password: ''
            }
        }
    },
    computed: {
        ...mapGetters(['companyInfo']),
        companyInfo: function () {
            return JSON.parse(sessionStorage.companyInfo ? sessionStorage.companyInfo : '{}');
        }
    },

    // created() {
    //     // this.$store.dispatch('getCompanyInfo');
    // },

    methods: {
        checkLoginInfo() {
            let that = this;
            (!this.userInfo.username) && (this.nameErr = true) && (this.nameErrText = '请输入邮箱');
            (!this.userInfo.password) && (this.pswErr = true) && (this.pswErrText = '请输入密码');

            // if(!/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.userInfo.username)){
            //     this.nameErr = true;
            //     this.nameErrText = '请输入正确的邮箱格式';
            // }

            // /^[\x21-\x7E]+$/  特殊字符正则
            // /^[^&#<>'\\\"\\\\|+%\\\\\\\\]*$/

            if(/[%\s+]/.test(this.userInfo.password)){
                this.errorTip("密码格式不正确");
                return;
            }

            if (!this.nameErr && !this.pswErr) {
                this.$http.post('api/user/login', this.userInfo).then(res => {  
                    if(res.status == 200 ){
                        switch(res.res_data.code){
                            case 0:
                                var loginTime = new Date().getTime();
                                sessionStorage.loginTime = loginTime;
                                this.$func.getUserInfo(true,info=>{
                                    this.$router.replace({ name: 'dashboard' });
                                    this.successTip("登录成功");
                                })
                                break;
                            case 1:
                                this.errorTip("用户名不存在");
                                break;
                            case 2:
                                this.errorTip("密码错误");
                                break;   
                            case 3:
                                this.errorTip(res.res_data.message);
                                break;
                        }
                    }
                    // console.log(res);
                    // switch (parseInt(res.data.status)) {
                    //     case 200:
                    //         var loginTime = new Date().getTime();
                    //         sessionStorage.loginTime = loginTime;
                    //         this.$router.replace({ name: 'dashboard' });
                    //         break;

                    //     case 900:
                            
                    // }
                }).catch(function (err) {
                    console.log("hahaha");
                    // switch (error.response.status) {
                    //     case 403:
                    //         if (error.response.data.code == 1) {
                    //             that.nameErr = true;
                    //             that.nameErrText = error.response.data.message;
                    //         } else {
                    //             that.pswErr = true;
                    //             that.pswErrText = error.response.data.message;
                    //         };
                    //         break;
                    // };

                });
            }
        },
        hideErrTip: function (type, msg) {
            (type == 'name') && msg && (this.nameErr = false);
            (type == 'psw') && msg && (this.pswErr = false);
        },
    },

}
</script>

<style scoped>
    ::-webkit-input-placeholder {
        color: #fff;
    }

    :-moz-placeholder {
        color: #fff;
    }

    ::-moz-placeholder {
        color: #fff;
    }

    :-ms-input-placeholder {
        color: #fff;
    }

    .container-login {
        width: 408px;
        text-align: center;
        position: absolute;
        top: 50%;
        margin-top: -160px;
        left: 50%;
        margin-left: -204px;
        z-index: 2;
    }

    form {
        font-size: 0;
    }

    .wrap-input {
        border-bottom: 1px solid #fff;
        position: relative
    }

    label[for=user-login-name],
    label[for=user-login-psw] {
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 0;
        width: 45px;
        height: 40px
    }

    label[for=user-login-name] {
        background: url(../assets/image/login-name.png) 0 center no-repeat;
    }

    label[for=user-login-psw] {
        background: url(../assets/image/login-password.png) 0 center no-repeat;
    }

    img.icon-logo-big {
        width: 104px;
        margin-bottom: 63px;
        opacity: 0.85;
    }

    img.icon-logo-small {
        margin-left: 34px;
        width: 30px;
        height: 30px;
        vertical-align: middle
    }

    #user-login-name,
    #user-login-psw {
        width: 360px;
        height: 40px;
        font-size: 15px;
        line-height: 40px;
        vertical-align: middle;
        color: #fff;
        border: none;
        outline: none;
        background: none;
    }

    .btn-submit-login {
        background: #01b6ad;
        border-radius: 5px;
        width: 312px;
        height: 38px;
        line-height: 38px;
        outline: 0;
        border: none;
        font-size: 17px;
        color: #ffffff;
        letter-spacing: 2.4px;
        margin-top: 59px;
        cursor: pointer;
    }

    .btn-submit-login:hover {
        background-color: #01A8A0;
    }

    .btn-submit-login:active {
        background-color: #019C94;
    }

    .show-error {
        white-space: nowrap;
        position: absolute;
        left: 420px;
        padding: 0 30px;
        border-radius: 4px;
        height: 40px;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        background: rgba(50, 50, 50, .75)
    }

    .show-error:before {
        content: '';
        position: absolute;
        height: 16px;
        width: 11px;
        left: -10px;
        top: 12px;
        background: url(../assets/image/error-text-radius.png) no-repeat;
    }

    .wrap-login {
        width: 100%;
        height: 100%;
    }


    .bg{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .bg:after{
        content:"";
        display: block;
        position: absolute;
        top:0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0,0,0,.6);
    }



    nav {
        opacity: .61;
        background: #000;
        height: 60px;
        line-height: 60px;
        text-align: left;
        z-index: 2;
        position: fixed;
        width:100%;
        top:0;
        left:0;
    }

    span {
        font-size: 12px;
        color: #fcfcfc;
        letter-spacing: 1px;
        line-height: 12px;
        margin-left: 10px;
        vertical-align: middle
    }

</style>



// WEBPACK FOOTER //
// Login.vue?370c3538